/**
 * Валидация email по основным правилам (без проверки TLD по списку)
 * @param email email для проверки
 * @returns true если email валиден, иначе false
 */
export function validateEmail(email: string): boolean {
    if (typeof email !== 'string' || email.length > 254) {
        return false;
    }
    // Пробелы по краям запрещены
    if (email !== email.trim()) {
        return false;
    }
    // Невидимые символы внутри запрещены
    if (/[\s\n\r\t]/.test(email)) {
        return false;
    }
    // Базовая структура
    if (!/^[а-яА-Яa-zA-Z0-9_.+-]+@[а-яА-Яa-zA-Z0-9-]+\.[а-яА-Яa-zA-Z0-9-.]+$/.test(email)) {
        return false;
    }
    // Локальная и доменная части
    const parts = email.split('@');
    if (parts.length !== 2) {
        return false;
    }
    const localPart = parts[0];
    const domain = parts[1];
    if (localPart.length > 64 || localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) {
        return false;
    }
    if (domain.length > 255) {
        return false;
    }
    const domainParts = domain.split('.');
    if (domainParts.length < 2) {
        return false;
    }
    for (let i = 0; i < domainParts.length; i++) {
        if (domainParts[i].length > 63) {
            return false;
        }
    }
    const tld = domainParts[domainParts.length - 1];
    // TLD должен быть минимум 2 символа и состоять только из букв
    if (!/^[a-zA-Z]{2,}$/.test(tld)) {
        return false;
    }
    for (let i = 0; i < domainParts.length - 1; i++) {
        const part = domainParts[i];
        if (
            part.length > 63 ||
            part.startsWith('-') ||
            part.endsWith('-') ||
            part.includes('--') ||
            !/^[а-яА-Яa-zA-Z0-9-]+$/.test(part)
        ) {
            return false;
        }
    }
    return true;
} 